import logo from '../img/letil-logo.png';
import loc from '../img/loc.png';

import './Location.scss';
import { useI18n } from '../i18n/i18n';

export function Location() {
    const t = useI18n();
    return <>
        <section id="helyszin" className="location">
            <h2>{t.location.h2}</h2>
            <div className="place">
                <div>
                    <strong>Le Til Kúria</strong>
                    <div>
                        <img src={logo} alt="Logo" />
                    </div>
                </div>
                <div className="img-card" />
                <div>
                    <strong>{t.location.address}</strong>
                    <div>
                        <img src={loc} alt="Location" />
                    </div>
                </div>
            </div>
            <div>
                <a className="button-link" href="https://letilkuria.hu" rel="noopener noreferrer" target="_blank">
                    letilkuria.hu
                </a>
            </div>
        </section>
        <section id="meta" className="quarter">
            <div className="photo">
                <h2>{t.location.photo}</h2>
                <div className="instagram">
                    <p>@feyer_photography</p>
                    <a href="https://www.instagram.com/feyer_photography/" rel="noopener noreferrer" target="_blank">
                        <img src="https://www.instagram.com/static/images/ico/favicon-192.png/68d99ba29cc8.png" alt="Instagram" />
                    </a>
                </div>
            </div>
        </section>
        <section className="quarter">
            <div className="photo" style={{ padding: '16px', textAlign: 'center' }}>
                <h2>{t.location.master}</h2>
                <div className="instagram">
                    <p>{t.location.masterText1}</p>
                    <p dangerouslySetInnerHTML={{ __html: t.location.masterText2.replace('{{name}}', '<strong>Papp Sándor Alex</strong><br />') }} />
                    <p>📞 +36 30 553 3258</p>
                </div>
            </div>
        </section>
    </>;
}
